let ui = {
  "Game_continue_button_label": "продолжить",
  "EventInfo_msg_label": "Сообщение:",
  "Game_continue_msg": "Была обнаружена незавершенная игра, желаете продолжить?",
  "Game_start_button_label": "Начать игру",
  "game_finish_msg": "Спасибо за игру!\nПосле закрытия этого окна произойдёт перегрузка страницы",
  "EditButton": {
    "btn_label": "Послать изменения на сервер",
    "error_msg": "Возникла ошибка. Возможно, изменения не были зафиксированы, хотя скорее всего таки были",
    "msg_label": "Причины редактирования:",
    "panel_title": "Редактировать текст",
    "success_msg": "Изменения были сохранены"
  },
  "EmptyFormMsg": {
    "text": "Сейчас ходит другой игрок. Дождитесь своего хода"
  },
  "Greeting": {
    "authors": "Разработка © 2016 «ЮрИнфоР»",
    "subtitle": "При участии эксперта проекта «Климатически нейтральная хозяйственная деятельность. Внедрение НДТ в РФ.» Майр К.",
    "title": "Прототип деловой игры\n«Получение экологического разрешения»"
  },
  "Header": {
    "admin": "Админка",
    "debug": "Отладка",
    "help": "Справка",
    "hint": "Подсказка",
    "restart": "Начать заново"
  },
  "Login": {
    "info": "Авторизация позволяет связать действия в рамках сессии с одним пользователем.\nПользователь связывается с условным именем — строкой, которая уникальна для каждого.\nПользователи могут принадлежать разным категориям: админы, эксперты, игроки и т.д.\nАвторизация необходима для определения возможностей, доступных инструментов и прав,\nа также для привязки изменений, произведённых в режиме эксперта.\nПароль нужен для того, чтобы предотвратить обстоятельства, когда один эксперт действует от имени другого\nили когда игрок получает доступ к инструментам, способным испортить доступную версию игры.\n",
    "login": "Логин\n",
    "login_info": "имя может содержать латинские буквы, арабские цифры, дефис, подчеркивание и точку\n",
    "password": "Пароль\n",
    "password_info": "при первом входе введённый пароль связывается с именем,\nпри повторном — необходимо повторить пароль\n",
    "submit": "Продолжить\n",
    "title": "Авторизация\n"
  },
  "Intro": {
    "info": "<Полезная информация об игре>\n\nДля пользователей:\nна верхней панеле есть кнопка «Справка», дающая информацию об интерфейсе игры.\n\nДля экспертов:\nпри наведении на текст (кнопку, сообщение, заголовок и т.п.) появляется иконка редактирования. Нажмите на неё для открытия диалогового окна редактирования текста. Используйте это окно для замечаний, относящихся к конкретному тексту.\n\nДля админов:\nспециально для вас на верхней панеле будет кнопка с редиректом в админку.",
    "intro": "",
    "title": "Об игре"
  },
  "MessagePanel": {
    "last": "К последнему сообщению",
    "next": "К следующему сообщению",
    "page": "сообщение: ${current-page} из ${page-count}",
    "prev": "К прошлому сообщению",
    "you": "Вы"
  },
  "RoleSelectionPanel": {
    "tip": "Перейти к действиям,\n которые может\n совершить %s"
  },
  "ModelRoleSelectionPanel": {
    "tips": {
      "adviser" : "Здесь можно получить помощь советника для прохождения игры.",
      "colleague" : "Можно узнать мнение коллеги по некоторым вопросам. Иногда он бывает прав."
    }
  },
  "WaitOption": {
    "tip": "Пропустить / Ожидать"
  }
};

export default ui;
